<script setup lang="ts">
import {
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTrigger,
} from 'radix-vue';
import Img from '~/components/Img.vue';
import SmallButton from '~/components/SmallButton.vue';

const slots = useSlots();
const hasHeader = computed(() => slots.header !== undefined);
const hasFooter = computed(() => slots.footer !== undefined);
</script>

<template>
  <DialogRoot>
    <DialogTrigger class="block text-left">
      <slot name="trigger" />
    </DialogTrigger>
    <DialogPortal>
      <DialogOverlay
        class="data-[state=open]:animate-overlayShow fixed inset-0 z-[2000] bg-[#303030]/[.7]"
      />
      <DialogContent>
        <div
          class="data-[state=open]:animate-contentShow fixed left-[50%] top-[50%] z-[2001] max-h-[85vh] w-full max-w-[336px] translate-x-[-50%] translate-y-[-50%] overflow-auto focus:outline-none"
        >
          <div class="modal">
            <div class="modal_frame_top"></div>
            <div class="modal__body">
              <div class="flex justify-center">
                <slot name="header" />
              </div>
              <div :class="{ 'mt-4': hasHeader }">
                <slot name="body" />
              </div>
              <div v-if="hasFooter" class="mt-4">
                <slot name="footer" />
              </div>
              <div v-else class="mt-4 flex justify-center">
                <DialogClose as="div" class="flex justify-center">
                  <SmallButton variant="close" />
                </DialogClose>
              </div>
              <DialogClose class="absolute right-6 top-6">
                <Img alt="" src="/images/modal/modal_close_button.svg" />
              </DialogClose>
            </div>
            <div class="modal_frame_bottom"></div>
          </div>
        </div>
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>

<style scoped>
.modal {
  position: relative;
}

.modal_frame_top,
.modal_frame_bottom {
  width: calc(100% - 16px);
  height: 24px;
  background-color: #f8f8f1;
  transform: translateX(8px);
}

.modal_frame_top {
  margin-bottom: -1px;
}
.modal_frame_bottom {
  margin-top: -1px;
}

.modal_frame_top::before,
.modal_frame_top::after,
.modal_frame_bottom::before,
.modal_frame_bottom::after {
  position: absolute;
  width: 24px;
  height: 24px;
  content: '';
  background-image: url(/images/modal/modal_edge.svg);
  background-size: cover;
}
.modal_frame_top::before {
  bottom: 0;
  left: -8px;
}
.modal_frame_top::after {
  top: 0;
  right: -8px;
  transform: scale(-1, 1);
}
.modal_frame_bottom::before {
  bottom: 0;
  left: -8px;
  transform: scale(1, -1);
}
.modal_frame_bottom::after {
  right: -8px;
  bottom: 0;
  transform: scale(-1, -1);
}

.modal__body {
  padding: 1px 24px;
  background-color: #f8f8f1;
}
</style>
